import React from 'react'
import T from 'prop-types'
import merge from 'deepmerge'
import { DEFAULT_FEATURES } from 'constants/features'

const Context = React.createContext({})

export default Context

export const FeatureProvider = ({ children, features }) => {
  const mergedFeatures = merge(DEFAULT_FEATURES, features)

  return <Context.Provider value={mergedFeatures}>{children}</Context.Provider>
}

FeatureProvider.propTypes = {
  children: T.element.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  features: T.object,
}

FeatureProvider.defaultProps = {
  features: {},
}
